const disabledUserAgents = [
    // Safari
    /^((?!chrome|android).)*safari/i,

    // iOS
    /(ipad|iphone|ipod)/i
];

function isBrowserEnabled() {
    return disabledUserAgents.every((x) => !x.test(navigator.userAgent));
}

function hasWebGLFeatures() {
    try {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('webgl') ||
            canvas.getContext('experimental-webgl');
        const exts = ctx.getSupportedExtensions();

        return Boolean(
            canvas && ctx && exts
        );
    } catch (e) {
        return false;
    }
}

function hasFeatures() {
    return hasWebGLFeatures();
}

export default function allowImmersive() {
    return hasFeatures() && isBrowserEnabled();
}



// WEBPACK FOOTER //
// ./src/js/util/allow-immersive.js